export const META_GET_COUNTRIES = "META_GET_COUNTRIES";
export const META_SET_COUNTRIES = "META_SET_COUNTRIES";
export const GET_META_TRACKER_PLATFORMS = "GET_META_TRACKER_PLATFORMS";
export const SET_META_TRACKER_PLATFORMS = "SET_META_TRACKER_PLATFORMS";
export const GET_META_AD_PLATFORMS = "GET_META_AD_PLATFORMS";
export const SET_META_AD_PLATFORMS = "SET_META_AD_PLATFORMS";
